import { isPossiblePhoneNumber } from 'react-phone-number-input';

export function validateEmail(value: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return {
    isValid: emailRegex.test(value),
    errorMessage: 'Please enter a valid email address',
  };
}

export function validatePhone(value: string) {
  if (!value || value.trim() === '') return { isValid: true };

  const normalizedPhone = value.trim();
  const isEmptyOrOnlyCountryCode =
    normalizedPhone === '' || /^\+\d{1,4}$/.test(normalizedPhone) || normalizedPhone === '+';

  return {
    isValid: isEmptyOrOnlyCountryCode || isPossiblePhoneNumber(value),
    errorMessage: 'Please enter a valid phone number',
  };
}
